import UserStatus from "./UserStatus";
import BatteryIndicator from "./BatteryIndicator";
import pole from "/Layer_1.png?url";
import img1 from "/partly-cloudy.png?url";
import img2 from "/Lightning.png?url";
import img3 from "/light.png?url";
import img4 from "/hail.png?url";
import img5 from "/windy.png?url";

const Detail = ({
  onClose = () => {},
  title = "Default Title",
  code = "N/A",
  name = "N/A",
  location = "N/A",
  lat = "N/A",
  lng = "N/A",
  active = false,
  hasScreen = false,
  children = null,
  isMaster = false,
  sensors = {},
  masterId = "###",
  screenCode = "###",
  screenModel = "###",
  installDate = "###",
  masterCode = "###",
}) => {
  const batteryPercentage = sensors?.battery100 ?? "N/A";
  const batteryRemaining = sensors?.batteryRemaining ?? "N/A";

  const formatDate = (dateString) => {
    if (!dateString || dateString === "###") return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <div className="BranchModal">
      <div className="weather-top-panel">
        <button className="close-button" onClick={onClose}>
          &times;
        </button>
        <div className="flexdetail">
          {title !== "รายละเอียดเสา" && (
            <h2 className={title === "รายละเอียดเสา" ? "wide-title" : ""}>
              {title}
            </h2>
          )}
          <div className="detailFlexTitle">
            {title !== "รายละเอียดเสา" && (
              <div className="detailcomponent">
                <UserStatus isOnline={hasScreen} />
              </div>
            )}
          </div>
          <div className="detailPole">{children}</div>
        </div>
        {title === "จอ LED" && (
          <>
            <div className="screen-details">
              <label>รหัสจอ</label>
              <label>รุ่นจอ</label>
              <label>วันที่ติดตั้ง</label>
              <strong>{screenCode}</strong>
              <strong>{screenModel}</strong>
              <strong>{formatDate(installDate)}</strong>
            </div>
            <br />
            <hr />
          </>
        )}
        <div
          className={`gridDetail ${
            title === "รายละเอียดเสา" ? "with-margin-top" : ""
          }`}
        >
          <h3>รายละเอียดเสา</h3>

          <div className="detailcomponent">
            <UserStatus isOnline={active} />
          </div>
          <div className="detailpoleH6">
            <h6>เสา{isMaster ? "หลัก" : "รอง"}</h6>
          </div>
          
        </div>

        {!isMaster && (
          <div className="maindetailpole">
            <label>เสาหลักที่ควบคุม</label>
            <h3>{masterCode}</h3>
          </div>
        )}

        <div className="detailmainpole">
          <div className="griddetailpole">
            {[
              { label: "รหัสเสา", value: code },
              { label: "ชื่อเสา", value: name },
              { label: "ประเภทเสา", value: `เสา${isMaster ? "หลัก" : "รอง"}` },
              { label: "ตำแหน่งติดตั้ง", value: location },
              { label: "ละติจูด", value: lat },
              { label: "ลองจิจูด", value: lng },
            ].map(({ label, value }) => (
              <div className="gridpole" key={label}>
                <label>{label}</label>
                <strong>{value || "N/A"}</strong>
              </div>
            ))}
          </div>
          <div className="imgpole">
            <BatteryIndicator
              percentage={batteryPercentage}
              remainingTime={batteryRemaining} // Passing batteryRemaining to the BatteryIndicator
            />
            <img src={pole} alt="Pole" />
          </div>
        </div>

        <br />
        <hr />
        <br />
        <div className="griddetalfooter">
          {isMaster && (
            <>
              <DetailSection
                imgSrc={img1}
                data={[
                  {
                    label: "อุณหภูมิ (°C)",
                    value: sensors?.temperature ?? "N/A",
                  },
                  {
                    label: "ปริมาณน้ำฝน (มิลลิเมตร)",
                    value: sensors?.rainDaily ?? "N/A",
                  },
                  { label: "ความชื้น (%)", value: sensors?.humidity ?? "N/A" },
                ]}
              />
              <DetailSection
                imgSrc={img4}
                data={[
                  { label: "PM 2.5 µg./m3", value: sensors?.pm2_5 ?? "N/A" },
                  { label: "PM 1 µg./m3", value: sensors?.pm1 ?? "N/A" },
                  { label: "PM 10 µg./m3", value: sensors?.pm10 ?? "N/A" },
                ]}
              />
              <DetailSection
                imgSrc={img5}
                data={[
                  { label: "ความกดอากาศ", value: sensors?.pressure ?? "N/A" },
                  {
                    label: "ความเร็วลม (กม./ชม.)",
                    value: sensors?.windGustSpeed ?? "N/A",
                  },
                  { label: "ทิศทางลม", value: sensors?.windDirection ?? "N/A" },
                ]}
              />
            </>
          )}
          <DetailSection
            imgSrc={img2}
            data={[
              { label: "แรงดันไฟ (V)", value: sensors?.voltage ?? "N/A" },
              { label: "กระแสไฟ (Ampere)", value: sensors?.amperage ?? "N/A" },
              { label: "กำลังไฟ (W)", value: sensors?.wattage ?? "N/A" },
            ]}
          />
          <DetailSection
            imgSrc={img3}
            data={[
              { label: "ค่าส่องสว่าง (Lux)", value: sensors?.lux ?? "N/A" },
              { label: "ค่าความสว่าง (%)", value: sensors?.lux100 ?? "N/A" },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

const DetailSection = ({ imgSrc, data }) => (
  <div className="deatilgridpole">
    <img src={imgSrc} alt="Sensor icon" />
    <div className="dtilpole">
      {data.map(({ label, value }) => (
        <div key={label}>
          <label>{label}</label>
          <strong>{value || "N/A"}</strong>
        </div>
      ))}
    </div>
  </div>
);

export default Detail;
